import styled from '@emotion/styled'

export const FilePreviewContainer = styled.div`
  align-self: center;
  height: 276px;
  aspect-ratio: 1 / 1.41;
`
